export default {
  SET_DEPENDENCIES: '@WS/SET_DEPENDENCIES',
};
